import React from "react";
import { MdCheckCircle, MdWarningAmber, MdLock, MdHelpOutline, MdErrorOutline, MdBolt } from "react-icons/md";
import { elakayAutoText } from "../dataElakay";

// Vocabulaire de statut partagé par le tab Manual (comparaison champ par
// champ) et le tab Automatic (résultat des actions) -- une seule palette de
// badges pour toute la section Synchronization.
const VARIANTS = {
    match: { icon: MdCheckCircle, className: "sync-badge--match", label: () => elakayAutoText("h_sync_badge_match", "Match") },
    different: { icon: MdWarningAmber, className: "sync-badge--different", label: () => elakayAutoText("h_sync_badge_different", "Different") },
    locked: { icon: MdLock, className: "sync-badge--locked", label: () => elakayAutoText("h_sync_badge_locked", "Locked") },
    missing: { icon: MdHelpOutline, className: "sync-badge--missing", label: () => elakayAutoText("h_sync_badge_missing", "Missing") },
    success: { icon: MdCheckCircle, className: "sync-badge--success", label: () => elakayAutoText("h_sync_badge_success", "Synced") },
    error: { icon: MdErrorOutline, className: "sync-badge--error", label: () => elakayAutoText("h_sync_badge_error", "Failed") },
    partial: { icon: MdWarningAmber, className: "sync-badge--partial", label: () => elakayAutoText("h_sync_badge_partial", "Partial") },
    enabled: { icon: MdBolt, className: "sync-badge--success", label: () => elakayAutoText("h_sync_badge_enabled", "Enabled") },
    disabled: { icon: MdHelpOutline, className: "sync-badge--muted", label: () => elakayAutoText("h_sync_badge_disabled", "Disabled") },
    soon: { icon: MdHelpOutline, className: "sync-badge--muted", label: () => elakayAutoText("h_sync_badge_soon", "Coming soon") },
};

const SyncStatusBadge = ({ variant = "missing", label, className = "" }) => {
    const config = VARIANTS[variant] || VARIANTS.missing;
    const Icon = config.icon;
    return (
        <span className={`sync-badge ${config.className} ${className}`}>
            <Icon />
            {label || config.label()}
        </span>
    );
};

export default SyncStatusBadge;
